module.exports = __webpack_public_path__ + "img/ic_share_wa.ca96fa1.svg";